// Copyright (c) 2026 Celadon Development LLC, All rights reserved.
// Author Vasily Klyuev <vasily.klyuev@celadon.ae>
import * as types from './actionTypes';

export function startLoader() {
  return { type: types.REDEEM_START_LOADER };
}

export function stopLoader() {
  return { type: types.REDEEM_STOP_LOADER };
}

export function changeCode(payload) {
  return { type: types.REDEEM_CHANGE_CODE, payload };
}

export function changeAmount(payload) {
  return { type: types.REDEEM_CHANGE_AMOUNT, payload };
}

export function scanVoucher() {
  return { type: types.REDEEM_SCAN_VOUCHER };
}

export function scanVoucherSuccess(payload) {
  return { type: types.REDEEM_SCAN_VOUCHER_SUCCESS, payload };
}

export function redeemVoucher() {
  return { type: types.REDEEM_VOUCHER };
}

export function redeemVoucherSuccess(payload) {
  return { type: types.REDEEM_VOUCHER_SUCCESS, payload };
}

/** message: { error: bool, text: string } */
export function setMessage(payload) {
  return { type: types.REDEEM_SET_MESSAGE, payload };
}

export function reset() {
  return { type: types.REDEEM_RESET };
}
